/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { match, matchPath } from "react-router";
import { t } from "i18n";
import Sidebar from "components/sidebar/sidebar";
import Menu from "components/menu/menu";
import { STORY_ANALYTICS, SECTION_ANALYTICS, AUTHOR_ANALYTICS } from "../routes";

type Props = { match: match; isBannerPresent: boolean };

const menuItems = () => [
  { label: t("analytics.story_analytics"), pathName: STORY_ANALYTICS, path: "/analytics/story/view/4-hours" },
  { label: t("analytics.section_analytics"), pathName: SECTION_ANALYTICS, path: "/analytics/section/view/4-hours" },
  { label: t("analytics.author_analytics"), pathName: AUTHOR_ANALYTICS, path: "/analytics/author/view/4-hours" }
];

class AnalyticsSidebar extends React.Component<Props> {
  render() {
    const { match } = this.props;
    return (
      <Sidebar isBannerPresent={this.props.isBannerPresent}>
        <Menu
          items={menuItems()}
          getItemLabel={(item) => item.label}
          routeTo={(item) => item.path}
          isItemSelected={(item) => !!matchPath(match.url, { path: item.pathName, exact: true })}
          title={t("analytics.sidebar.title")}
        />
      </Sidebar>
    );
  }
}

export default AnalyticsSidebar;
